import { Injectable } from '@angular/core';
import { AccountService } from './account.service';

@Injectable()
export class InboxPreviewService {

  constructor(private accountService: AccountService) {
  }

  openInboxPreview() {
    const url = `${this.accountService.baseUrl}/inboxpreview?accountKey=${this.accountService.accountKey}` +
      `&orgname=${this.accountService.orgname}&userlcid=${this.accountService.userlcid}` +
      `&userid=${this.accountService.userid}&sessionId=${this.accountService.sessionId}` +
      `&id=${this.accountService.id}&typename=${this.accountService.typename}` +
      `&version=${this.accountService.version}&callerPage=ddeditor`;

      window.open(url, '_blank');
  }
}
